import styled from 'styled-components';
import ButtonOutline from 'components/buttons/ButtonOutline/styles';
import ButtonPrimary from 'components/buttons/ButtonPrimary/styles';

export const DriverOptOutWrap = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 14px;

  &.onlyAction {
    display: contents;
  }

  button {
    flex: 0 0 auto;
  }
`;

export const DriverOptOutContent = styled.div`
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 9px 14px;
  border-radius: 999px;
  background: #f0f2f5;
  white-space: nowrap;

  &::before {
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #12b76a;
    flex: 0 0 auto;
  }
`;

export const DriverOptOutTitle = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #232d3a;
`;

export const DriverOptOutCountdown = styled.span`
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  /* Fixed width so the buttons next to it don't move as the digits tick. */
  display: inline-block;
  width: 3.2em;
`;

export const DriverOptOutModalRow = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  margin-top: 12px;

  > div {
    flex: 1;
    margin-top: 0;
  }
`;

export const DriverOptOutModalValue = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 34px;
  font-weight: 800;
  line-height: 1;
  color: #232d3a;
  font-variant-numeric: tabular-nums;
  /* Fixed width, wide enough for "3:30" and "Locked": the text next to it must not
     re-wrap every second as the digits change width. */
  flex: 0 0 104px;
  text-align: right;
  white-space: nowrap;

  &.urgent {
    color: #d92d20;
  }

  &.locked {
    font-size: 24px;
    color: #0e8f55;
  }
`;

export const DriverOptOutBarTrack = styled.div`
  height: 6px;
  margin-top: 18px;
  border-radius: 999px;
  background: #eceef3;
  overflow: hidden;
`;

export const DriverOptOutBarFill = styled.div`
  height: 100%;
  border-radius: 999px;
  background: #12b76a;
  transition: width 900ms linear;

  &.urgent {
    background: #d92d20;
  }
`;

export const DriverOptOutActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`;

const modalButton = `
  border-radius: 999px;
  padding: 13px 40px;
  font-size: 16px;
  font-weight: 700;
  white-space: nowrap;
`;

export const DriverOptOutSecondaryButton = styled(ButtonOutline)`
  &.ButtonMedium {
    ${modalButton}
    border: 1.5px solid #232d3a;
    color: #232d3a;

    &:hover {
      background-color: #f0f2f5;
    }
  }
`;

export const DriverOptOutPrimaryButton = styled(ButtonPrimary)`
  &.ButtonMedium {
    ${modalButton}
  }
`;

export const DriverOptOutModalTitle = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 26px;
  font-weight: 800;
  letter-spacing: -0.01em;
  color: #232d3a;
`;

export const DriverOptOutModalText = styled.div`
  font-family: 'Poppins', sans-serif;
  font-size: 17px;
  line-height: 1.5;
  color: #36424f;
  margin-top: 12px;
`;

export const SelfDeliveryNoteWrap = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 20px;
  padding: 14px 16px;
  border-radius: 8px;
  background: #f1f5f9;
  border: 1px solid #dbe3ea;
`;
